import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SwitzerlandFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14484'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14484)'>
				<rect
					width='20'
					height='14'
					fill='#FF0000'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57199 8.40005H6.04818C5.86408 8.40005 5.71484 8.25081 5.71484 8.06672V5.93338C5.71484 5.74929 5.86408 5.60005 6.04818 5.60005H8.57199V3.13338C8.57199 2.94929 8.72122 2.80005 8.90532 2.80005H11.0958C11.2799 2.80005 11.4291 2.94929 11.4291 3.13338V5.60005H13.9529C14.137 5.60005 14.2863 5.74929 14.2863 5.93338V8.06672C14.2863 8.25081 14.137 8.40005 13.9529 8.40005H11.4291V10.8667C11.4291 11.0508 11.2799 11.2 11.0958 11.2H8.90532C8.72123 11.2 8.57199 11.0508 8.57199 10.8667V8.40005Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default SwitzerlandFlagIcon;
